import React from 'react';
import { useIntl } from 'react-intl';
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import devicePhoto from '../../static/calibration/calibration-fourth-step.png';
import { TextField } from '@material-ui/core';
import { NumberFormatCustom } from './stepsHelper';
import { useField } from 'formik';
import { useBem } from '../../Bem';
import { useCurrentMeasurment, steps } from '../helper';

export const Step4 = () => {
  const bem = useBem('step4');
  const intl = useIntl();
  const [field, meta, helpers] = useField({ name: 'cameraOffset' });
  const currentMeasurment = useCurrentMeasurment();

  return (
    <div className={bem.elem('container').cls()}>
      <p className={bem.elem('text').cls()}>
        <span>(4/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.descriptionStep_4, { value: currentMeasurment.value.toLowerCase() })}</span>
      </p>
      <div className={bem.elem('text-field').cls()}>
        <TextField
          variant="standard"
          style={{width: 125 }}
          type="text"
          fullWidth={false}
          placeholder={`0 ${currentMeasurment.value.toLowerCase()}`}
          name="cameraOffset"
          onChange={field.onChange}
          value={field.value}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          InputProps={{
            inputComponent: NumberFormatCustom as any,
          }}
        />
      </div>
      <div className={bem.elem('wrapper').cls()}>
        <img className={bem.elem('photo').mods('step4').cls()} src={devicePhoto} />
      </div>
    </div>
  );
};
